import { createContext, useContext } from "react";
import type { Identifier } from "ra-core";

export type TaskSelection = {
  selectedIds: Identifier[];
  onToggleItem: (id: Identifier) => void;
};

/**
 * Row selection for the task list's bulk actions.
 *
 * Each due-date bucket renders inside its own `useList` context, which shadows
 * the page's `<List>`. Passing the page's selection down through this context
 * keeps the rows wired to the one selection `<BulkActionsToolbar>` reads,
 * instead of five per-bucket ones that no toolbar would ever see. A row outside
 * the task list page (contact aside, mobile list) finds no provider and simply
 * renders no checkbox.
 */
export const TaskSelectionContext = createContext<TaskSelection | null>(null);

export const useTaskSelection = () => useContext(TaskSelectionContext);
